<!-- L'en-tete est un FRERE de `mat-dialog-content`, pas son enfant.
     Le `<h2 mat-dialog-title>` etait place a l'interieur du contenu : Material calcule alors la
     zone defilante en incluant le titre, qui defile avec le texte au lieu de rester en place, et
     l'espacement du titre est celui d'un paragraphe. Meme structure que les boites d'ACA. -->
<div class="alg-note-dialog__header">
  <h2 class="alg-note-dialog__title">
    <mat-icon class="alg-note-dialog__title-icon">note_add</mat-icon>
    Créer une note
  </h2>
  <button mat-icon-button mat-dialog-close [disabled]="saving" aria-label="Fermer" title="Fermer">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="alg-note-dialog__content">
  <p class="alg-note-dialog__intro">Un fichier texte sera créé dans le dossier courant.</p>

  <div class="alg-note-dialog__error" role="alert" *ngIf="error">
    <mat-icon>error_outline</mat-icon>
    <span>{{ error }}</span>
  </div>

  <mat-form-field class="alg-note-dialog__field">
    <mat-label>Nom de la note</mat-label>
    <input
      matInput
      cdkFocusInitial
      name="nom"
      autocomplete="off"
      required
      [maxlength]="maxNameLength"
      [pattern]="namePattern"
      [(ngModel)]="nom"
      (ngModelChange)="error = ''"
      (keyup.enter)="onSubmit()"
      #nomRef="ngModel"
      aria-label="Nom de la note"
      data-automation-id="alg-add-note-name"
    />
    <!-- Annonce l'extension que le service ajoute, pour que le nom saisi n'ait pas a la porter. -->
    <span matTextSuffix class="alg-note-dialog__suffix">.txt</span>
    <mat-hint align="end">{{ nom.length }} / {{ maxNameLength }}</mat-hint>
    <mat-error *ngIf="nomRef.hasError('required')">Le nom est obligatoire.</mat-error>
    <mat-error *ngIf="!nomRef.hasError('required') && nomRef.hasError('pattern')">
      Caractères interdits : {{ forbiddenChars }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="alg-note-dialog__field">
    <mat-label>Contenu</mat-label>
    <textarea
      matInput
      name="note"
      rows="8"
      required
      [(ngModel)]="note"
      (ngModelChange)="error = ''"
      #noteRef="ngModel"
      aria-label="Contenu de la note"
      data-automation-id="alg-add-note-content"
    ></textarea>
    <mat-error *ngIf="noteRef.hasError('required')">Le contenu est obligatoire.</mat-error>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="saving">Annuler</button>
  <!-- `saving` garde le double-clic : la creation partait autant de fois qu'on appuyait. -->
  <button mat-flat-button (click)="onSubmit()" [disabled]="!canSubmit || saving" data-automation-id="alg-add-note-submit">
    {{ saving ? 'Création…' : 'Créer' }}
  </button>
</mat-dialog-actions>
